import { Breadcrumbs, Link, Typography } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'

export interface LinkPath {
  href: string
  label: string
}

export interface GlobalBreadcrumbsProps {
  current?: string
  path?: LinkPath[]
}

const GlobalBreadcrumbs = ({ current, path }: GlobalBreadcrumbsProps) => {
  return (
    <Breadcrumbs>
      <Link
        underline="hover"
        color="inherit"
        href="/"
        sx={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center', mt: 0.5 }}
      >
        <HomeIcon />
      </Link>
      {path?.map((p) => (
        <Link key={p.href} underline="hover" color="inherit" href={p.href}>
          {p.label}
        </Link>
      ))}
      {current && <Typography sx={{ color: 'text.primary' }}>{current}</Typography>}
    </Breadcrumbs>
  )
}

export default GlobalBreadcrumbs
